import styled from 'styled-components'

export const CARD_HEIGHT = 250

const StyledCard = styled.li`
  background-color: ${(p) => p.theme.v2.surface.cream500};
  border: 1px solid rgba(45, 50, 70, 0.24);
  border-radius: 24px;
  height: ${CARD_HEIGHT}px;
  min-height: ${CARD_HEIGHT}px;
  min-width: 350px;
  padding: 32px 24px;
  width: 350px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    padding: 32px 24px;
    height: 310px;
    min-height: 310px;
    min-width: 255px;
    width: 255px;
  }

  h3 {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
    line-height: 38px; // doesn't match existing pre-defined typography
    margin: 0;
    max-width: 294px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
    }
  }

  p {
    border-left: 3px solid #e2e2e2;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    margin: 36px 0 0 0;
    padding-left: 16px;
  }
`

type GutShotGuideSectionCardProps = {
  title: string
  description: string
}

export const GutShotGuideSectionCard = ({ title, description }: GutShotGuideSectionCardProps) => {
  return (
    <StyledCard>
      <h3>{title}</h3>
      <p>{description}</p>
    </StyledCard>
  )
}
